import { get as lodashGet, isEmpty } from 'lodash';
import { StateCreator } from 'zustand';

import { LeadChannelState } from './types/LeadChannelState';
import { LeadChannelStateDependencies } from './types/LeadChannelStateDependencies';

export const keysToPersist: string[] = [
  'lastFetchedLeadChannelCode',
  'leadChannel',
];

export const leadChannelStore =
  ({
    useApiStore,
  }: LeadChannelStateDependencies): StateCreator<LeadChannelState> =>
  (set, get) => ({
    initLeadChannelFinished: false,
    lastFetchedLeadChannelCode: null,
    leadChannel: {},

    computed: {
      get displayLabel(): string {
        const leadChannel = get().leadChannel;

        return lodashGet(leadChannel, 'displayLabel', '');
      },
      get isValidLeadChannel(): boolean {
        return !isEmpty(get().leadChannel);
      },
      get primaryLogoURL(): string {
        const leadChannel = get().leadChannel;

        return lodashGet(leadChannel, 'primaryLogo.url', '');
      },
    },

    initLeadChannel: (
      leadChannelCode: string | null | undefined,
    ): Promise<void> => {
      const { lastFetchedLeadChannelCode } = get();

      if (!leadChannelCode || lastFetchedLeadChannelCode === leadChannelCode) {
        set({ initLeadChannelFinished: true });
        return;
      }

      set({ lastFetchedLeadChannelCode: leadChannelCode });

      const portalHttpRequest = useApiStore.getState().portalApi();

      return portalHttpRequest
        .get(`/ui-configuration/lead-channel/${leadChannelCode}`)
        .then((leadChannel) => {
          set({
            leadChannel,
          });
        })
        .catch((error: unknown) => {
          console.error(error);
        })
        .finally(() => {
          set({ initLeadChannelFinished: true });
        });
    },
  });
